module.exports = __webpack_public_path__ + "static/media/dlaczego-warto-spedzac-czas-z-dzieckiem.d22cb6d5.png";